import DataStructure, { sanitize } from "./DataStructure";
import { deepFreeze, timestampToDate } from "../util/misc";

export const UNMATCHED_EMAIL_FIELDS = {
  messageId: "",
  internetMessageId: "",
  conversationId: "",
  subject: "",
  from: null,
  toRecipients: [],
  ccRecipients: [],
  bodyPreview: "",
  body: "",
  bodyType: "text",
  hasAttachments: false,
  attachments: [],
  extractedProjectID: "",
  status: "pending",
  receivedDateTime: null,
  created: null,
};
deepFreeze(UNMATCHED_EMAIL_FIELDS);

export default class UnmatchedEmail extends DataStructure {
  constructor(id, data = {}) {
    data = sanitize(data, UNMATCHED_EMAIL_FIELDS);

    // Convert to Date
    data.receivedDateTime = timestampToDate(data.receivedDateTime);
    data.created = timestampToDate(data.created);

    super(data);

    this.id = id || null;
  }

  // Database

  get path() {
    return UnmatchedEmail.getPath(this.id);
  }

  static getPath(id) {
    let path = "unmatched-emails";
    if (id) {
      path += `/${id}`;
    }
    return path;
  }

  static toFirestore(email) {
    return email.data;
  }

  static fromFirestore(snapshot, options) {
    const data = snapshot.data(options);
    return new UnmatchedEmail(snapshot.id, data);
  }

  // Formatting

  get fromDisplay() {
    if (!this.data.from) return "";
    return this.data.from.name || this.data.from.address || "";
  }

  get fromAddress() {
    return this.data.from ? this.data.from.address : "";
  }

  toString() {
    return this.data.subject;
  }
}
